export default {
  OFFERS: {
    TITLE: 'Jobs',
    PROPOSED_BANNER: {
      TITLE: 'Offers pending to be created',
      SUBTITLE: 'You have pending selection folders. Complete them to create the offers and invite your candidates.',
      VIEW_BTN: 'View →',
      TABLE: {
        DATE: 'Date',
        DATE_TOOLTIP: 'Date the offer was created',
        TITLE_COL: 'Title / Position',
        CANDIDATES: 'Candidates to invite',
        CANDIDATES_LABEL: 'candidates',
        CANDIDATES_TOOLTIP: 'Once you create the offer, the candidates will receive an invitation to apply for the vacancy',
        STATUS: 'Status',
        ACTIONS: 'Actions',
        BADGE: 'Offer pending to be created',
        BADGE_TOOLTIP: 'Create the offer: the candidates you selected will be invited automatically and, once they apply, you\'ll be able to manage them.',
        CREATE_BTN: 'Create offer',
        DISCARD_BTN: 'Delete',
        SHOW_MORE: 'See more',
        SHOW_LESS: 'See less',
      },
      CONFIRM_DISCARD: {
        HEADER: 'Delete proposed offer',
        MESSAGE: 'Are you sure you want to delete this proposed offer?',
        ACCEPT: 'Delete',
        REJECT: 'Cancel',
      },
      DELETE_SUCCESS: 'Proposed offer deleted successfully.',
      INVITE_SUCCESS: 'Candidates invited successfully. Proposed offer completed.',
      PARTIAL_INVITE: 'Offer created, but there was an issue inviting some candidates. You can invite them manually from the offer detail.',
    },
    ACTIVE_OFFERS: 'Active jobs',
    NEW_OFFER: 'Post a job',
    SHOW_PUBLISHED: 'Published:',
    DESCRIPTION: 'Description',
    TABLE: {
      TITLE: 'Jobs',
      HEADER: {
        DATE: 'Date',
        DATE_TOOLTIP: 'Date the job was posted.',
        TITLE: 'Job title',
        LOCATION: 'Branch',
        TYPE: 'Workplace',
        CONTRACT_TYPE: 'Job type',
        WORKING_DAY: 'Schedule',
        ACTIONS: 'Offer Actions',
        DUPLICATE_ACTIONS: 'Actions',
        SALARY_RANGE: 'Salary range',
        CANDIDATES: 'Applicants',
        CANDIDATES_TOOLTIP: 'Applicants who have recorded their intro video and are in the selection process',
        SELECTED: 'Finalists',
        STATUS: 'Status',
      },
      FILTERS: {
        CITY: 'All cities',
        LOCATION: 'All branches',
        STATUS: 'All statuses',
        TYPE: 'All jobs',
        SEARCH_OFFER: 'Search jobs',
        SEARCH: 'Search',
        SEARCH_CANDIDATES: 'Search candidates',
        NO_LOCATIONS: 'Select a branch first',
        NO_CITIES: 'No cities available',
        NO_OFFERS: 'No jobs available',
      },
      NO_DATA: 'You don\'t have any jobs yet.',
      NO_DATA_DESCRIPTION: 'Post your first job using the "Post a job" button above.',
      FIRST_OFFER_MODAL: {
        HEADER: 'Welcome to wokap!',
        MESSAGE: 'This is your jobs dashboard. You don\'t have any yet. Would you like to post your first one now?',
        ACCEPT: 'Post first job',
        REJECT: 'Not right now',
      },
      CONFIRM_PAUSE: {
        HEADER: 'Pause job',
        MESSAGE: 'While paused, the job won\'t accept new applicants, but candidates already in the pipeline will remain active. Are you sure you want to pause this job?',
        ACCEPT: 'Pause',
        REJECT: 'Cancel',
      },
      CONFIRM_OPEN: {
        HEADER: 'Resume job',
        MESSAGE: 'By resuming, the job will be active and visible to new applicants again. Are you sure you want to resume this job?',
        ACCEPT: 'Resume',
        REJECT: 'Cancel',
      },
      CONFIRM_DISCARD: {
        HEADER: 'Close job',
        MESSAGE: 'Closing this job means it won\'t accept new applicants. All registered candidates will receive this message:<br/><br/>Thank you for your interest in {{companyName}}. The selection process has been completed and your application was not selected. We invite you to stay tuned for future opportunities.<br/><br/>Would you like to send a personalized message? Go to the Registered section, select the candidates you wish, and send them your message.<br/><br/>Are you sure you want to close this job?',
        ACCEPT: 'Close job',
        REJECT: 'Cancel',
      },
      CONFIRM_DELETE: {
        HEADER: 'Delete job',
        MESSAGE: 'Are you sure you want to delete this job? This action cannot be undone and the job will be permanently removed from your dashboard.',
        ACCEPT: 'Delete',
        REJECT: 'Cancel',
      },
      BEFORE_DELETE: {
        HEADER: 'Before you delete',
        MESSAGE: 'To maintain a great employer brand, please close the job first so active candidates are notified. Once closed, you can delete it safely.',
        ACCEPT: 'Close job',
        REJECT: 'Cancel',
      },
      DELETE_SUCCESS: 'Job deleted successfully.',
      PIN_SUCCESS: 'Job pinned successfully. The job is now at the top of your dashboard. Drag it to change its position and organize your jobs as you like.',
      UNPIN_SUCCESS: 'Job unpinned successfully.',
      ACTIONS: {
        PIN: 'Pin job',
        UNPIN: 'Unpin job',
        SEE: 'View/Edit job',
        DUPLICATE: 'Duplicate job',
        START: 'Resume job',
        PAUSE: 'Pause job',
        END: 'Close job',
        SHARE: 'Copy/Share job',
        REMOVE: 'Delete job',
        DISABLED_PAUSED: 'This job is paused',
        DISABLED_CLOSED: 'This job is closed',
        SEE_DISABLED_CLOSED: 'This job is closed. You can view it, but editing is disabled.',
        SHARE_DISABLED_PAUSED: 'This job is paused and cannot be shared.',
        SHARE_DISABLED_CLOSED: 'This job is closed and cannot be shared.',
        EDIT_INTERVIEW_DISABLED_CLOSED: 'This job is closed. You cannot create or edit interviews.',
        PAUSE_DISABLED_CLOSED: 'This job is closed and cannot be paused.',
        RESUME_DISABLED_CLOSED: 'This job is closed and cannot be resumed.',
        END_DISABLED_CLOSED: 'This job is already closed.',
        // Legacy keys (keep for compatibility)
        START_DISABLED_CLOSED: 'This job is already closed and cannot be paused.',
        CREATE_INTERVIEW_DISABLED_CLOSED: 'This job is closed. You cannot create or edit interviews.',
      },
      DUPLICATING: {
        TITLE: 'Duplicating...',
        MESSAGE: 'The job is being duplicated. We\'ll notify you and redirect you when it\'s ready.',
      },
    },
    CANDIDATES: {
      NEW: 'To review',
      UNREAD_CHATS: 'Chats',
      PROCESS: 'Interviews',
      TOOLTIP: {
        NEW: 'Candidates pending review',
        UNREAD_CHATS: 'Chats pending reply',
        PROCESS: 'Completed interviews',
      },
    },
    TYPE: {
      REMOTE: 'Remote',
      IN_PERSON: 'On-site',
      HYBRID: 'Hybrid',
    },
    CONTRACT_TYPE: {
      PERMANENT: 'Permanent',
      TEMPORARY: 'Temporary',
      PROJECT_BASED: 'Contract',
      FREELANCE: 'Freelance',
      INTERNSHIP: 'Internship',
    },
    WORKING_DAY: {
      FULL_TIME: 'Full-time',
      PART_TIME: 'Part-time',
      PER_HOUR: 'Hourly',
    },
    SALARY: {
      PAYMENT_TYPE: {
        MONTHLY: 'Monthly',
        BIWEEKLY: 'Biweekly',
        WEEKLY: 'Weekly',
        ANNUAL: 'Annually',
        HOURLY: 'Hourly',
        PROJECT: 'Per project',
      },
      CURRENCY: {
        EUR: 'EUR',
        USD: 'USD',
        MXN: 'MXN',
        COP: 'COP',
        ARS: 'ARS',
        PEN: 'PEN',
        CLP: 'CLP',
        GTQ: 'GTQ',
        CRC: 'CRC',
        BRL: 'BRL',
        CAD: 'CAD',
        DOP: 'DOP',
        VES: 'VES',
      },
      NET_GROSS_TYPE: {
        GROSS: 'Gross',
        NET: 'Net',
      },
      LABEL: {
        PAYMENT_TYPE: 'Pay period',
        CURRENCY: 'Currency',
        NET_GROSS_TYPE: 'Salary type',
        AMOUNT_FROM: 'Minimum amount',
        AMOUNT_TO: 'Maximum amount (Optional)',
      },
      PLACEHOLDER: {
        PAYMENT_TYPE: 'Select an option',
        CURRENCY: 'Select currency...',
        NET_GROSS_TYPE: 'Select type...',
        AMOUNT_FROM: 'e.g., 2000',
        AMOUNT_TO: 'e.g., 3500',
      },
      VALIDATION: {
        ALL_OR_NONE: 'Salary info is optional. If provided, these four fields are required: minimum amount, pay period, currency, and salary type.',
        AMOUNT_TO_GREATER: 'Maximum amount must be greater than the minimum.',
        ONLY_NUMBERS: 'Only whole numbers are allowed.',
      },
      CLEAR: 'Clear all salary info',
    },
    STATUS: {
      OPEN: 'Open',
      PAUSED: 'Paused',
      CLOSED: 'Closed',
    },
    CANDIDATE_STATUS: {
      OFFER_WITHOUT_INTERVIEW: 'N/A',
      OFFER_WITHOUT_INTERVIEW_TOOLTIP: 'This job has no interview set up. Go to "Create interview" to set one up.',
      ENROLLED: 'Applied',
      PROCESS: 'Shortlisted',
      SELECTED: 'Finalist',
      DISCARDED: 'Rejected',
      SUGGESTED: 'Suggested',
      PROCESS_INTERVIEW_ANSWERED: 'Completed',
      PROCESS_INTERVIEW_PENDING: 'Sent',
      PROCESS_NEW_ANSWER: 'New answer',
      PROCESS_NEW_QUESTION: 'New question',
      PROCESS_SPECIFIC_QUESTION_PENDING: 'Direct question pending',
      PROCESS_SPECIFIC_QUESTION_ANSWERED: 'Direct question answered',
      PROCESS_INTERVIEW_PENDING_SEND: 'Not sent',
      RATED: 'Rated',
      RATING_UPDATED: 'Rating updated',
      NEW_COMMENT: 'Note added',
      UPDATED_COMMENT: 'Note updated',
      DELETED_COMMENT: 'Note deleted',
      PROCESS_INTERVIEW_NOT_APPLICABLE: 'N/A',
      STATUS_SUGGESTED: 'Suggested',
      STATUS_ENROLLED: 'Applied',
      STATUS_PROCESS: 'Shortlisted',
      STATUS_SELECTED: 'Finalist',
      STATUS_DISCARDED: 'Rejected',
      INTERVIEW_RESENT: 'Interview resent',
      INTERVIEW_SENT: 'Interview sent',
      INTERVIEW_ANSWERED: 'Interview completed',
      INTERVIEW_QUESTIONS_REGENERATED: 'Interview questions regenerated',
      SPECIFIC_QUESTIONS_SENT: 'Direct questions sent',
      SPECIFIC_QUESTIONS_ANSWERED: 'Direct questions answered',
    },
    ERRORS: {
      OFFER_NOT_FOUND: 'The selected job does not exist or cannot be edited.',
      TITLE_NOT_BLANK: 'Job title is required.',
      ENTITY_LOCATION_NOT_FOUND: 'The selected location does not exist.',
      OFFER_TYPE_NOT_BLANK: 'Workplace type is required.',
      OFFER_STATUS_NOT_BLANK: 'Job status is required.',
      OFFER_ALREADY_HAS_THIS_STATUS: 'The job already has this status.',
      QUESTION_MIN_LENGTH: 'Question must be at least 3 characters.',
      QUESTION_NOT_BLANK: 'Question is required.',
      AI_ERROR: 'We couldn\'t process this request. Please try rephrasing your prompt.',
      FILE_NOT_BLANK: 'File is required.',
      SALARY_RANGE_TOO_LONG: 'Salary range cannot exceed 15 characters.',
      VIDEO_OFFER_NOT_FOUND: 'Video upload failed. Please try again.',
      FILE_MIME_TYPE_WRONG: 'File must be a video.',
      FILE_MAX_SIZE: 'File size cannot exceed 50MB.',
      SUMMARY_NOT_BLANK: 'Description is required.',
      VIDEO_NOT_VERTICAL: 'Video must be in vertical format.',
      INVALID_VIDEO_FILE: 'Video format not supported. We recommend using MP4.',
      QUESTION_MAX_LENGTH: 'Question cannot exceed 255 characters.',
      PROMPT_REQUIRED: 'Prompt field is required.',
      FAILED_TO_LOAD_LOCATIONS: 'Failed to load locations. Please try again.',
      OFFER_CREATION_ERROR: 'Failed to create job. Please try again.',
      UNKNOWN_ERROR: 'An unexpected error occurred. Please try again.',
    },
    DETAIL: {
      TITLE: 'Job',
      BACK: 'Back to Jobs',
      ACTIONS: {
        DUPLICATE: 'Duplicate',
        DELETE: 'Delete',
        PAUSE: 'Pause',
        RESUME: 'Resume',
        END: 'Close',
        SEE: 'View/Edit',
        SHARE: 'Share',
        PREVIEW: 'Preview',
        CREATE_INTERVIEW: 'Create interview',
        EDIT_INTERVIEW: 'Edit interview',
        CREATE_INTERVIEW_TOOLTIP: 'Create an interview',
        EDIT_INTERVIEW_TOOLTIP: 'Edit interview',
      },
      KPI: {
        TOTAL: 'Applicants',
        WITHOUT_CLASSIFICATION: 'Unrated',
        // eslint-disable-next-line @typescript-eslint/naming-convention
        '4_5_STARS': '4 & 5 stars',
        INTERVIEWEES: 'Interviewed',
        SELECTED: 'Finalists',
      },
      FILTER: {
        BUTTON: 'Filter candidates',
        // Tooltip for the small X button and dynamic button label when showing count
        RESET_TOOLTIP: 'Clear filters',
        BUTTON_COUNT_SINGULAR: '1 Filter applied',
        BUTTON_COUNT_PLURAL: '{{count}} Filters applied',
        DEFAULT: {
          PLACEHOLDER: 'Filter by',
          DEFAULT: 'Default',
          ALL_REQUIREMENTS: 'All qualifications',
          MINIMUM_REQUIREMENTS: 'Minimum qualifications',
          DESIRED_REQUIREMENTS: 'Preferred qualifications',
          CUSTOM: 'Custom',
        },
        INTERVIEW: {
          PLACEHOLDER: 'Interview',
          ALL: 'All',
          INTERVIEW_ANSWERED: 'Completed',
          INTERVIEW_SENT: 'Sent',
          INTERVIEW_PENDING: 'Not sent',
          INTERVIEW_NA: 'N/A',
        },
        CLASSIFICATION: {
          PLACEHOLDER: 'Rating',
          ALL: 'All',
          NO_CLASSIFICATION: 'Unrated',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          '0_STARS': '0 stars',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          '1_STARS': '1 star',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          '2_STARS': '2 stars',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          '3_STARS': '3 stars',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          '4_STARS': '4 stars',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          '5_STARS': '5 stars',
        },
        STATUS: { PLACEHOLDER: 'Stage' },
      },
      FILTER_SIDEBAR: {
        CLEAR_FILTERS_BTN: 'Clear filters',
        CLEAR_FILTERS_TOOLTIP: 'Remove all selected filters and see all candidates again.',
        APPLY_FILTERS_BTN: 'Apply filters',
        APPLY_FILTERS_TOOLTIP: 'See all candidates who meet the selected filters.',
        RESET: 'Clear filters',
        CLEAR_BTN: 'Clear filters',
        CLEAR_TOOLTIP: 'Clear filters',
        // Tooltip for the small X button in table toolbars
        RESET_TOOLTIP: 'Clear filters',
        // Button label when there are N active filters
        BUTTON_COUNT_SINGULAR: '1 Filter applied',
        BUTTON_COUNT_PLURAL: '{{count}} Filters applied',
        APPLY_BTN: 'Apply',
        APPLY_TOOLTIP: 'Apply filters',
        TITLE: 'Filter candidates',
        STAGE_QUESTION: 'Which stage do you want to filter?',
        SEARCH_PLACEHOLDER: 'Search...',
        TABS: {
          ALL: 'Applicants',
          SUGGESTED: 'Suggested',
          ENROLLED: 'To review',
          IN_PROCESS: 'Pre-selected',
          SELECTED: 'Finalists',
          DISCARDED: 'Discarded',
        },
        SUBTITLE: 'Which stage do you want to filter?',
        ENROLLED_TITLE: 'Filter "To review"',
        CONTACTED_FILTER_LABEL: 'Contacted',
        INVITED_FILTER_LABEL: 'Invited',
        IN_PROCESS_TITLE: 'Filter "Shortlisted"',
        SELECTED_TITLE: 'Filter "Finalists"',
        SUGGESTED_TITLE: 'Filter "Suggested"',
        DISCARDED_TITLE: 'Filter "Rejected"',
        ALL_TITLE: 'Filter "Applicants"',
        SCOPE: {
          LABEL: 'Filter scope',
          ALL: 'All applicants in this offer',
          ONLY: 'Only',
        },
        COLUMN: {
          PROFILE: 'Profile',
          PROCESS: 'Process',
        },
        FORMATION: {
          TITLE: 'Education',
          SOURCE: 'Profiles of enrolled candidates',
          EMPTY: 'No data available',
        },
        COUNTRY: {
          TITLE: 'Country',
          SOURCE: 'Profiles of enrolled candidates · single selection',
          EMPTY: 'No data available',
        },
        CITY: {
          TITLE: 'City',
          LOCKED: 'Select a country first',
          EMPTY: 'No cities available for this country',
        },
        LANGUAGES: {
          TITLE: 'Languages',
          SOURCE: 'Offer languages · minimum level (≥)',
          EMPTY: 'No languages defined in this offer',
          SELECT_LANGUAGE: 'Select a language to set the minimum level',
          LEVEL_LABEL: 'Minimum level',
          BASIC: 'Basic (A1-A2)',
          INTERMEDIATE: 'Intermediate (B1)',
          ADVANCED: 'Advanced (B2-C1)',
          NATIVE: 'Native (C2)',
        },
        HARD_SKILLS: {
          TITLE: 'Hard skills',
          EMPTY: 'No data available',
        },
        SOFT_SKILLS: {
          TITLE: 'Soft skills',
          EMPTY: 'No data available',
        },
        OTHER_COMP: {
          TITLE: 'Other competencies',
          EMPTY: 'No data available',
        },
        INTERVIEW: {
          TITLE: 'Interview',
          INTERVIEW_ANSWERED: 'Completed',
          INTERVIEW_SENT: 'Sent',
          INTERVIEW_PENDING_SEND: 'Not sent',
        },
        CLASSIFICATION: {
          TITLE: 'Rating',
          NO_CLASSIFICATION: 'Unrated',
          MIN_HINT: 'Click the same star to remove the rating.',
        },
        MINIMUM_REQUIREMENTS: {
          TITLE: 'Minimum qualifications',
          FORMATION: 'Education',
          EXPERIENCE: 'Experience',
          OTHER: 'Other',
        },
        DESIRED_REQUIREMENTS: { TITLE: 'Preferred qualifications' },
        STATUS: {
          TITLE: 'Stage',
          ENROLLED: 'To review',
          IN_PROCESS: 'Shortlisted',
          SELECTED: 'Finalists',
          DISCARDED: 'Rejected',
        },
        OTHER: { TITLE: 'Other filters' },
        COMPATIBILITY: {
          TITLE: 'AI Match level',
          TOP: 'Top match',
          TOP_RANGE: '90%+ · Ideal fit for the role',
          HIGH: 'Good match',
          HIGH_RANGE: '80% - 90% · Meets key criteria',
          POTENTIAL: 'Potential match',
          POTENTIAL_RANGE: 'Under 80% · Worth exploring',
        },
        DISCARD_INVERSE: {
          BUTTON: 'Discard',
          TOOLTIP: 'Discard candidates depending on whether or not they meet the selected filters.',
          DISABLED_TOOLTIP: 'To discard candidates, enable at least one filter.',
          MATCHING: {
            LABEL: 'Discard matches',
            DESCRIPTION: 'Discard candidates who <b>DO</b> meet the selected filters.',
          },
          NOT_MATCHING: {
            LABEL: 'Discard non-matches',
            DESCRIPTION: 'Discard candidates who do <b>NOT</b> meet the selected filters.',
          },
          CONFIRM: {
            TITLE: 'Confirm discard',
            QUESTION_MATCHING_SINGULAR: 'Do you confirm you want to discard 1 candidate who <b>DOES</b> meet these requirements?',
            QUESTION_MATCHING_PLURAL: 'Do you confirm you want to discard {{count}} candidates who <b>DO</b> meet these requirements?',
            QUESTION_NOT_MATCHING_SINGULAR: 'Do you confirm you want to discard 1 candidate who does <b>NOT</b> meet these requirements?',
            QUESTION_NOT_MATCHING_PLURAL: 'Do you confirm you want to discard {{count}} candidates who do <b>NOT</b> meet these requirements?',
            RECOVER_NOTE_SINGULAR: 'You can recover them from "Discarded" anytime.',
            RECOVER_NOTE_PLURAL: 'You can recover them from "Discarded" anytime.',
            CANCEL: 'Cancel',
            CONFIRM: 'Discard',
          },
          NOTIFICATION: {
            TITLE: 'Filter-based discard',
            SUCCESS: {
              TEXT_MATCHING: 'Candidates who met the selected filters have been discarded.',
              TEXT_NOT_MATCHING: 'Candidates who did not meet the selected filters have been discarded.',
            },
            ERROR: { TEXT: 'Could not complete the discard. Please try again.' },
            ALREADY_DISCARDED: {
              TITLE: 'Candidates are already discarded',
              TEXT_MATCHING: 'The candidates who meet the selected filters are already in "Discarded".',
              TEXT_NOT_MATCHING: 'The candidates who do not meet the selected filters are already in "Discarded".',
            },
            NONE_TO_DISCARD: {
              TITLE: 'No candidates to discard',
              TEXT_MATCHING: 'No candidate in this stage meets the selected filters.',
              TEXT_NOT_MATCHING: 'All candidates in this stage meet the selected filters.',
            },
          },
        },
      },
      TABLE: {
        TITLE: {
          ENROLLED: 'To review',
          IN_PROCESS: 'Shortlisted',
          SELECTED: 'Finalists',
          SUGGESTED: 'Suggested',
          DISCARDED: 'Rejected',
          ALL: 'Applicants',
        },
        CONTACTED: {
          CARD: 'Contacted',
          TOOLTIP: 'This candidate has already been contacted directly by you or someone from your company',
        },
        SUGGESTED_SEND_OFFER: { TOOLTIP: 'This candidate applied to this offer through an invitation sent by you or someone from your company' },
        VIEW: 'View',
        VIEWS_TOOLTIP: 'Explore the 3 available views to browse candidates. Each offers different tools to evaluate and organize your pipeline',
        VIEW_LIST_TOOLTIP: 'List',
        VIEW_CARDS_TOOLTIP: 'Card',
        VIEW_WOKAP_TOOLTIP: 'wokap',
        HEADER: {
          NAME: 'Name',
          MATCH: 'Match',
          MATCH_TOOLTIP: 'AI match percentage for this role',
          NOTES: 'Notes',
          POSITION: 'Role',
          CITY: 'City',
          COUNTRY: 'Country',
          REQUIREMENTS_MINIMUM: 'Min. Quals',
          REQUIREMENTS_MINIMUM_TOOLTIP: 'Minimum qualifications',
          REQUIREMENTS_DESIRED: 'Pref. Quals',
          REQUIREMENTS_DESIRED_TOOLTIP: 'Preferred qualifications',
          DATE: 'Applied on',
          DATE_TOOLTIP: 'Date the candidate applied to this job',
          INTERVIEW: 'Interview',
          INTERVIEW_TOOLTIP: 'Interview status',
          STATUS: 'Stage',
          CLASSIFICATION: 'Rating',
          ACTIONS: 'Actions Candidates',
        },
        ACTIONS: {
          SELECT: 'Advance to finalist',
          RESEND_INTERVIEW: 'Resend interview',
          SEND_INTERVIEW: 'Send interview',
          SEND_INTERVIEW_DISABLED_ANSWERED: 'This candidate has already completed the interview. Visit their profile to view it.',
          CREATE_INTERVIEW: 'Create interview',
          SEND_MESSAGE: 'Send message',
          RESTORE: 'Restore candidate',
          RESTORE_TOOLTIP: 'Restore rejected candidate',
          INTERESTED: 'Shortlist',
          OPEN_CHAT: 'Send message',
          DISCARD: 'Reject candidate',
          FINAL_INTERVIEW_MODAL: 'Manage Candidate',
          FINAL_INTERVIEW_MODAL_TOOLTIP: 'Schedule & contact',
          NOTES: 'Notes',
          ADVANCE: 'Advance candidate to next stage',
          ADVANCE_DISABLED_DISCARDED: 'You cannot advance a rejected candidate',
          ADVANCE_ERROR: {
            TITLE: 'Cannot advance',
            MESSAGE: 'You cannot advance rejected candidates. Please deselect them and try again.',
          },
          MOVE: 'Move candidate',
          SEND_QUESTION: 'Direct questions',
          SEND_QUESTION_TOOLTIP: 'Send direct questions to this candidate',
          SEND_QUESTION_TOOLTIP_MULTIPLE: 'Send direct questions to these candidates',
          DISABLED_MULTIPLE_SELECTION: 'Deselect candidates to use individual actions',
          SPECIFIC_QUESTIONS: {
            HEADER: 'Direct Questions',
            DESCRIPTION_MULTIPLE: 'These questions will be sent to the candidates for a video reply. It\'s almost like having them in front of you: upon reading the question, they get just 1-2 seconds before recording starts. Use this powerful tool for an authentic and natural assessment.',
            DESCRIPTION: 'These questions will be sent to the candidate for a video reply. It\'s almost like having them in front of you: upon reading the question, they get just 1-2 seconds before recording starts. Use this powerful tool for an authentic and natural assessment.',
            QUESTION_LABEL: 'Question {{ number }}',
            ADD_BUTTON: 'Add question',
            SEND_BUTTON: 'Send',
            AI: {
              SUBTITLE: 'Generate direct questions with AI based on your job post. You can edit them before sending.',
              COUNT_LABEL: 'Number of questions',
              COUNT_PLACEHOLDER: 'Select amount',
              TOPIC_LABEL: 'What topic should they focus on? (optional)',
              TOPIC_PLACEHOLDER: 'E.g.: availability, customer experience, motivation...',
              SUGGESTIONS: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                1: 'Availability and start date',
                // eslint-disable-next-line @typescript-eslint/naming-convention
                2: 'Salary expectations',
                // eslint-disable-next-line @typescript-eslint/naming-convention
                3: 'Motivation for the role',
                // eslint-disable-next-line @typescript-eslint/naming-convention
                4: 'Experience in similar roles',
                // eslint-disable-next-line @typescript-eslint/naming-convention
                5: 'Teamwork',
                // eslint-disable-next-line @typescript-eslint/naming-convention
                6: 'Handling pressure or challenges',
                // eslint-disable-next-line @typescript-eslint/naming-convention
                7: 'Language level',
                // eslint-disable-next-line @typescript-eslint/naming-convention
                8: 'Key technical skills',
              },
              GENERATE_BUTTON: 'Generate questions with AI',
              MANUAL_BUTTON: 'Write them myself',
              BACK_TO_OPTIONS: 'Back to AI options',
              LOADING: 'Generating direct questions with AI...',
              ERROR: 'Could not generate the questions. Try again or write them yourself.',
            },
          },
          DUPLICATE_LIMIT_MODAL: {
            SUMMARY: 'Limit reached',
            DETAIL: 'You can add up to 5 questions.',
          },
          SEND_QUESTION_SUCCESS_MODAL: {
            SUMMARY: 'Success',
            DETAIL: 'Questions sent successfully.',
          },
          SEND_QUESTION_FAILURE_MODAL: {
            SUMMARY: 'Error',
            DETAIL: 'There was an error sending the questions.',
          },
        },
        CARD: {
          REQUIREMENTS_MINIMUM: 'Min. Quals ({{ requirements_required }})',
          REQUIREMENTS_DESIRED: 'Pref. Quals ({{ requirements_desired }})',
        },
        ACTION_MULTIPLE: {
          SELECTED: 'Selected',
          SELECTED_PLURAL: 'Selected',
        },
        ENROLLED: {
          TITLE: 'To review',
          INFO: 'This section holds candidates who haven\'t been evaluated or assigned a stage yet. Review their profiles to decide if they move forward, get rejected, or stay here for now.',
        },
        IN_PROCESS: {
          TITLE: 'Shortlisted',
          INFO: 'These are the candidates you\'ve decided to move forward in the process. From here, you can evaluate them further, reach out directly, or send them the initial interview.',
        },
        SELECTED: {
          TITLE: 'Finalists',
          INFO: 'Candidates who made it to the final stage. Compare profiles, leave specific notes, reach out to them, and decide who gets the offer.',
        },
        SUGGESTED: {
          TITLE: 'Suggested candidates',
          INFO: 'In addition to the candidates who have already applied to your job, wokap suggests these other profiles. Review them and, if any stand out, invite them to apply so you can manage them and include them in your selection process.',
        },
        DISCARDED: {
          TITLE: 'Rejected candidates',
          INFO: 'Candidates who were disqualified during the process. You can log rejection reasons for future reference or internal compliance.',
        },
        ALL: {
          TITLE: 'Applicants',
          INFO: 'Every candidate who applied to this role, regardless of their current stage. Use this view to search, filter, and oversee your entire pipeline.',
        },
        NO_DATA: 'No candidates found in this stage with the current filters.',
      },
      NEW_CANDIDATES: {
        TITLE: 'New candidates',
        SUBTITLE: '{{amount}} new candidates have applied to your job',
        NO_DATA: 'No candidates have applied to your job yet',
        ACTIONS: {
          DEFAULT: 'All qualifications',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          1: 'Qualification 1',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          2: 'Qualification 2',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          3: 'Qualification 3',
        },
      },
      TIKTOK_VIEW: { TITLE: 'wokap view' },
      SUGGESTED_CANDIDATES: {
        TITLE: 'Suggested candidates',
        SUBTITLE: '{{amount}} new candidates might be a great fit.',
        SUBTITLE_SINGULAR: '{{amount}} new candidate might be a great fit.',
        NO_DATA: 'No suggested candidates match your job yet.\nNew people join wokap every day; as soon as we find a fit, they\'ll appear here.',
        MODAL: {
          TITLE: 'Suggested candidate',
          CANCEL: 'Dismiss',
          CONFIRM: 'Invite to apply',
          CONFIRM_TOOLTIP: 'Invite this person to apply for the role. Once they do, you can manage their pipeline.',
          ALREADY_SENT: 'You or someone from your company has already invited this person to apply for the job. When they accept the invitation, you can manage their pipeline.',
          VIEW_CANDIDATE: 'View candidate',
          MODAL_CONFIRMATION: {
            HEADER: 'Send invitation',
            CONTENT: 'Are you sure you want to invite this person to apply for your {{offer}} vacancy?',
            CONFIRM: 'Invite to apply',
            CANCEL: 'Cancel',
          },
        },
      },
      MODAL_CANDIDATES: {
        TITLE: 'Candidate',
        SHOW_MORE: 'View more',
      },
      OFFER_CHANGE_STATUS_CORRECTLY: 'Job status updated successfully.',
      CANDIDATE_DISCARDED_CORRECTLY: 'Candidate rejected successfully.',
      INTERVIEW_SENT_CORRECTLY: 'Interview sent successfully.',
      PREVIEW: {
        CONTRACT_TYPE: { TITLE: 'Job type' },
        LOCATION: { TITLE: 'Branch' },
        TYPE: { TITLE: 'Workplace' },
        SALARY: { TITLE: 'Salary' },
        WORKING_DAY: { TITLE: 'Schedule' },
        REQUIREMENTS_MINIMUM: {
          TITLE: 'Minimum qualifications',
          FORMATION: {
            TITLE: 'Education',
            EMPTY: 'No education required',
          },
          EXPERIENCE: {
            TITLE: 'Experience',
            EMPTY: 'No experience required',
          },
          OTHER: {
            TITLE: 'Other',
            EMPTY: 'No other required qualifications',
          },
          LANGUAGES: {
            TITLE: 'Languages',
            EMPTY: 'No language requirements',
          },
        },
        REQUIREMENTS_DESIRED: {
          TITLE: 'Preferred qualifications',
          LANGUAGES: {
            TITLE: 'Languages',
            EMPTY: 'No languages preferred',
          },
          EXPERIENCE: {
            TITLE: 'Experience',
            EMPTY: 'No experience preferred',
          },
          OTHER: {
            TITLE: 'Other',
            EMPTY: 'No other preferred qualifications',
          },
          EMPTY: 'No preferred qualifications',
        },
        DESCRIPTION: 'Description',
        INTERVIEW: 'Interview',
        QUESTIONS: '{{ number }} questions',
        EDIT_DESCRIPTION_SUCCESS: 'Description updated successfully.',
      },
      FINAL_INTERVIEW_MODAL: {
        TITLE: 'Manage Candidate',
        TITLE_ALT: 'Schedule & contact',
        AGENDA_OVERLAY: {
          OPTION_INTERVIEW: 'Schedule in-person or virtual meeting',
          OPTION_DOCUMENTS: 'Request documents',
          OPTION_VIRTUAL_TEST: 'Send forms / questionnaires',
          OPTION_CONTACT: 'Ask them to contact you',
          OPTION_CUSTOM_MESSAGE: 'Custom message',
          INTERVIEW_BULK_TOOLTIP: 'Appointments are scheduled individually. Select a single candidate. If you want to include several candidates in the same meeting, you\'ll need to schedule them one by one.',
        },
        STEP_INTRO: 'You\'re at the final step of your screening.',
        FINALISTS_INTRO: 'You have your finalists ready.',
        ACTION_INTRO: 'Now, choose how you want to move forward with each one.',
        EDIT_INSTRUCTION: 'Select an action:',
        SENT_MESSAGE: 'Message sent successfully',
        CALENDAR_CONFIRM: {
          TITLE: 'Schedule in calendar',
          MESSAGE: 'Would you like to schedule this event in your calendar?',
        },
        RE_SEND_CONFIRM: {
          TITLE: 'Resend interview',
          MESSAGE: 'Would you like to resend the interview to candidates with the updated questions?',
        },
        MESSAGE: {
          HEADER: 'Hi, your profile caught our eye and we\'d love to get to know you better.',
          FOOTER: 'Have a great day!',
        },
        ERROR: { UNSAVED_CHANGES: 'You have unsaved changes. Save or cancel before continuing.' },
        CONFIRM_SECTION_CHANGE: {
          HEADER: 'Unsaved changes',
          MESSAGE: 'You have unsaved changes here. What would you like to do?',
          SAVE_AND_CONTINUE: 'Save and continue',
          DISCARD_AND_CONTINUE: 'Discard changes',
          CANCEL: 'Stay here',
        },
        CONFIRM_CLOSE: {
          HEADER: 'Unsaved changes',
          MESSAGE: 'You have unsaved changes. What would you like to do before closing?',
          SAVE_AND_CLOSE: 'Save and close',
          DISCARD_AND_CLOSE: 'Discard and close',
          CANCEL: 'Keep editing',
        },
        INTERVIEW: {
          TITLE: 'We\'d like to schedule an interview with you:',
          DAY: 'Day',
          TIME: 'Time',
          DATE_TIME: 'Date & Time',
          SELECT_DATE_TIME: 'Select interview date and time',
          TIME_SELECTOR_INFO: 'Use the selectors below to adjust the time',
          ACCEPT: 'Apply',
          CLEAR: 'Clear',
          CANCEL: 'Cancel',
          TODAY: 'Today',
          FORMAT: 'Format',
          FORMAT_OPTIONS: {
            VIRTUAL: {
              LABEL: 'Virtual',
              LOCATION: 'Virtual meeting link',
            },
            IN_PERSON: {
              LABEL: 'On-site',
              LOCATION: 'Location for in-person interviews',
            },
          },
          MANAGE_DATA_BUTTON: 'Settings',
          MANAGE_DATA_TOOLTIP: 'Save time and avoid repeating the same information in every contact. Configure your details in wokap to auto-fill your messages to candidates. Each team member configures their own details. Below you can configure yours.',
          CALENDAR_EVENT_TITLE: 'Meeting with {candidateName} for {offerTitle}',
          MESSAGE_TEMPLATE: 'We\'d like to schedule an interview with you:\n\nDay:\t\t{{day}}\nTime:\t\t{{time}}\nFormat:\t{{format}}\n{{locationFormat}}:\t{{location}}\n\nPlease confirm if this works for you.',
          CALENDAR_WARNING: {
            MESSAGE: 'The candidate won\'t receive the calendar invite until you connect your calendar.',
            LINK: 'Connect calendar',
          },
        },
        DOCUMENTS: {
          TITLE: 'Please send us the following documents:',
          DOCUMENTS: 'Required documents',
          MESSAGE_TEMPLATE: 'Please send us the following documents here:\n\n{{documents}}',
        },
        VIRTUAL_TEST: {
          TITLE: 'Please complete the following:',
          TECHNICAL_TEST: 'Enter the link to the technical test or questionnaire',
        },
        CONTACT: {
          TITLE: 'Please reach out to us:',
          WHATSAPP: 'Via WhatsApp',
          PHONE: 'Via Phone Call',
          CONTACT_PERSON: 'Contact Person',
          EMAIL: 'Via Email',
          MANAGE_DATA_BUTTON: 'Settings',
          MANAGE_DATA_TOOLTIP: 'Save time and avoid repeating the same information in every contact. Configure your details in wokap to auto-fill your messages to candidates. Each team member configures their own details. Below you can configure yours.',
        },
        CUSTOM_MESSAGE: {
          TITLE: 'Custom message:',
          CUSTOM_MESSAGE: 'Type your message here.',
          MESSAGE_TEMPLATE: '\n{{customMessage}}',
        },
        SEND_MESSAGE: 'Send message',
        MESSAGE_PREVIEW: 'Message preview',
      },
      DIRECT_MESSAGE_CONFIG_MODAL: {
        HEADER: 'Direct message templates',
        TOOLTIP: 'Configure messages',
        INTRO_LABEL: 'Message intro',
        INTRO_PLACEHOLDER: 'e.g., Hi, your profile caught our eye and we\'d love to get to know you better.',
        INTRO_HELP: 'This text will automatically appear at the beginning of all messages in this section. You can update it anytime.',
        SUFFIX_LABEL: 'Message sign-off',
        SUFFIX_PLACEHOLDER: 'e.g., Have a great day!',
        SUFFIX_HELP: 'This text will automatically appear at the end of all messages in this section. You can update it anytime.',
        SAVE_SUCCESS: 'Settings saved successfully.',
        ERROR_LOAD: 'Failed to load settings.',
      },
      EXPANDABLE_CARD: {
        SEE_MORE: 'View more',
        SEE_LESS: 'View less',
      },
      CONFIRM_DUPLICATE: {
        HEADER: 'Duplicate job',
        MESSAGE: 'Are you sure you want to duplicate this job?',
        ACCEPT: 'Duplicate',
        REJECT: 'Cancel',
      },
      DUPLICATING: {
        TITLE: 'Duplicating...',
        MESSAGE: 'The job is being duplicated. We\'ll notify you and redirect you when it\'s ready.',
      },
      CANDIDATE_MOVED_SUCCESSFULLY: 'Candidate moved successfully.',
      CANDIDATES_MOVED_SUCCESSFULLY: 'Candidates moved successfully.',
      CONFIRM_MOVE: {
        HEADER: 'Are you sure you want to move this candidate?',
        ACCEPT: 'Move',
        REJECT: 'Cancel',
      },
      CONFIRM_MOVE_MULTIPLE: { HEADER: 'Are you sure you want to move these {{count}} candidates?' },
    },
    CREATE: {
      STEP_1: {
        HELLO: 'Hi {{ username }}!',
        TITLE_CREATE: 'Post a job',
        TITLE_EDIT: 'Edit job post',
        SELECT_LOCATION: 'Select location',
        LOCATION_MODE_QUESTION: 'Which location is this job for?',
        LOCATION_MODE_EXISTING: 'Existing branch',
        LOCATION_MODE_NEW: 'New branch',
        LOCATION_AUTO_PLACEHOLDER: 'Auto-filled based on your location',
        LOCATION_STATE_NOT_DETECTED_ERROR: 'Select a more precise address so this field can be auto-filled.',
        NO_BRANCHES_FOUND: 'No branches found',
        OFFER: 'Job post',
        OFFER_DESCRIPTION: 'Already have a job description? <br/>If not, we\'ll generate one for you.',
        FORM: {
          LABEL: {
            BRANCH: 'Location',
            BRANCH_ADDRESS: 'Location address',
            CREATE_NEW_BRANCH: 'If the location isn\'t listed.',
            CREATE_NEW_BRANCH_SUBTITLE: 'Click here to add a new one.',
            NEW_BRANCH_NAME: 'New location name',
            CITY: 'City',
            OFFER_TITLE: 'Job title',
            TYPE: 'Workplace',
            CONTRACT_TYPE: 'Job type',
            WORKING_DAY: 'Schedule',
            OFFER_SALARY: 'Salary details (Optional)',
            OFFER_SALARY_SUBTITLE: 'Including salary info helps attract more qualified candidates.',
          },
          PLACEHOLDER: {
            BRANCH_CITY: 'Select a city',
            BRANCH_DROPDOWN: 'Select a location',
            NEW_BRANCH_NAME: 'e.g., North Branch',
            CITY: 'Enter the city for the new branch',
            BRANCH_SEARCH: 'Search or type a location name',
            OFFER_TITLE: 'e.g., Product Designer',
            TYPE: 'Select workplace type',
            CONTRACT_TYPE: 'Select job type',
            WORKING_DAY: 'Select schedule',
            OFFER_SALARY: '$80,000 to $100,000 / year',
            OFFER_DESCRIPTION: 'Paste your description here',
            ADDRESS: 'Enter the address for the new branch',
            ADDRESS_HINT: 'Type an address and select one of the suggested options.',
            COUNTRY_HINT: 'Auto-filled when the location is selected on the map.',
            STATE_HINT: 'Auto-filled when the location is selected on the map.',
            CITY_HINT: 'Auto-filled when the location is selected on the map, or you can type it manually.',
          },
          MODAL_MAP: { TITLE: 'Map view' },
        },
        INFO: 'Providing a salary range boosts applications and promotes transparency.',
        FORM_ERRORS: { GLOBAL: 'Check the form: there are errors or missing required fields.' },
        DIALOG: {
          HEADER: 'Cancel job creation',
          HEADER_EDIT: 'Cancel edits',
          MESSAGE: 'Are you sure you want to cancel? Your progress will be lost.',
          MESSAGE_EDIT: 'Are you sure you want to cancel editing? Unsaved changes will be lost.',
          ACCEPT: 'Continue',
          ACCEPT_EDIT: 'Discard changes',
          REJECT: 'Go back',
          REJECT_EDIT: 'Keep editing',
        },
        GUARD: {
          EDITION_HEADER: 'Cancel job creation',
          EDITION_MESSAGE: 'Are you sure you want to cancel? Your progress will be lost.',
          EDITION_ACCEPT: 'Cancel creation',
          EDITION_REJECT: 'Keep creating',
        },
      },
      STEP_2: {
        TITLE: 'Minimum qualifications',
        INFO: 'These are the <b>must-haves</b> required to perform this role.',
        FORM: {
          LABEL: {
            EXPERIENCE: 'Experience',
            FORMATION: 'Education',
            OTHER: 'Other requirements',
          },
          PLACEHOLDER: {
            EXPERIENCE: 'e.g., 5+ years in project management',
            FORMATION: 'e.g., BS in Computer Science',
            OTHER: 'e.g., Expert in Figma',
          },
          LANGUAGE: {
            LABEL: {
              LANGUAGE: 'Language',
              LEVEL: 'Level',
              CERTIFICATION: 'International Certification (Optional)',
            },
            PLACEHOLDER: {
              LANGUAGE: 'Select a language',
              LEVEL: 'Select a level',
              CERTIFICATION: 'Not required',
            },
            LEVEL: {
              BASIC: 'Basic',
              INTERMEDIATE: 'Intermediate',
              ADVANCED: 'Advanced',
              NATIVE: 'Native',
            },
            CERTIFICATION: {
              NONE: 'Not required',
              A1: 'A1 (Beginner)',
              A2: 'A2 (Basic)',
              B1: 'B1 (Intermediate)',
              B2: 'B2 (Upper Intermediate)',
              C1: 'C1 (Advanced)',
              C2: 'C2 (Mastery)',
            },
          },
        },
        LANGUAGES: 'Languages',
        YEARS_EXPERIENCE: 'Years of experience',
        OTHER: 'Other requirements',
        ADD_LANGUAGE: 'Add language',
        SAVE_LANGUAGE: 'Save language',
        DELETE_LANGUAGE: 'Delete language',
        ADD: 'Add',
        DIALOG: {
          HEADER: 'Missing qualifications',
          MESSAGE: 'You haven\'t added any minimum qualifications. These are essential to ensure candidates meet the baseline expectations. Are you sure you want to continue without them?',
          ACCEPT: 'Continue',
          REJECT: 'Go back',
        },
        ERRORS: {
          AT_LEAST_ONE_REQUIRED: 'Please add at least one minimum qualification in any of the four fields.',
          LANGUAGE_PENDING: 'There is an unconfirmed language. Delete it or complete the entry.',
          LANGUAGE_REQUIRED: 'Select a language.',
          LEVEL_REQUIRED: 'Select a level.',
        },
        SUGGESTED_CHIPS: {
          WORKGROUP: 'Teamwork',
          PUNCTUALITY: 'Punctuality',
          RESPONSIBILITY: 'Responsibility',
          PROACTIVITY: 'Proactive',
          ADAPTABILITY: 'Adaptability',
          ORGANIZATION: 'Organization',
          PROBLEM_SOLVING: 'Problem-solving',
          ATTENTION_TO_DETAIL: 'Attention to detail',
          ONE_YEAR_EXPERIENCE: '1 year of experience',
          WORK_UNDER_PRESSURE: 'Ability to work under pressure',
        },
      },
      STEP_3: {
        TITLE: 'Preferred qualifications',
        INFO: 'These are the <b>nice-to-haves</b> that make a candidate stand out.',
        FORM: { PLACEHOLDER: { REQUIREMENTS: 'e.g., High level of WordPress' } },
        LANGUAGES: 'Languages',
        YEARS_EXPERIENCE: 'Years of experience',
        OTHER: 'Other qualifications',
        ADD_LANGUAGE: 'Add language',
        ADD: 'Add',
        OPTIONAL_STEP: 'This step is optional.',
        DIALOG: {
          HEADER: 'Regenerate description?',
          MESSAGE: 'Press "Yes" if you want to regenerate the description.<br /> Press "No" to keep the description your job post already had.',
          ACCEPT: 'Yes',
          REJECT: 'No',
        },
        SUGGESTED_CHIPS: {
          INDUSTRY_EXPERIENCE: 'Industry experience',
          LANGUAGES: 'Languages',
          LEADERSHIP: 'Leadership',
          DRIVERS_LICENSE: 'Driver\'s license',
          FLEXIBLE_SCHEDULE: 'Flexible schedule',
          CREATIVITY: 'Creativity',
          EASY_LEARNER: 'Fast learner',
          GOOD_WRITING: 'Strong writing skills',
          COMMUNICATION_SKILLS: 'Communication skills',
        },
        LOADING_LOCATIONS: 'Loading locations...',
      },
      STEP_4: {
        TITLE: 'Great!',
        INFO: 'Here is the AI-generated job description for <b>"{{ title }}"</b> based on the details you provided:',
        DESCRIPTION: 'Description',
        CHAT_PLACEHOLDER: 'Type a message...',
        EDIT: 'Edit manually',
        SAVE: 'Save',
        AI_PROMPT: {
          PLACEHOLDER: 'Type your adjustments here...',
          OFFER_CHANGES: 'Want to tweak the job description?',
        },
        SUGGESTED_CHIPS: {
          DESCRIBE_COMPANY: 'Expand on our company culture',
          USE_FORMAL_LANGUAGE: 'Make it sound more formal',
          // ADD_CHANGE_MANAGEMENT: 'Add change management responsibilities',
          SHORTER_AND_DIRECT: 'Make it shorter and direct',
          PROFESSIONAL_TONE: 'Use a more professional tone',
          REMOVE_GENERICS: 'Remove generic corporate jargon',
          YOUNG_CANDIDATES: 'Make it appealing to junior candidates',
          POSITION_BENEFITS: 'Highlight the role\'s perks and benefits',
          SKILL_EMPHASIS: 'Emphasize the core skills more',
          RELEVANT_AT_START: 'Put the most important details at the top',
        },
      },
      STEP_5: {
        TITLE: 'Add a video to your job post',
        SUBTITLE: 'Record a video for your job to make it more attractive to candidates. Tell them what makes your company special and what you\'re looking for in the ideal candidate. Use your job description text as a guide when recording the video.',
        SUBTITLE_LINK: 'View job text',
        CONTINUE_WITHOUT_VIDEO: 'Continue without video',
        UPLOAD_VIDEO: 'Upload video',
        REPLACE_VIDEO: 'Replace video',
        SKIP: 'Skip for now',
        CONTINUE: 'Continue',
        UPLOAD_VIDEO_SUCCESS: 'Video uploaded successfully.',
        UPLOAD_VIDEO_HELP: 'Video must be vertical and under 50MB.',
        VIDEO_REQUIRED: 'Upload a video or check the box',
      },
      STEP_6: {
        AI_PROMPT: {
          PLACEHOLDER: 'Type your adjustments for the questions here...',
          OFFER_CHANGES: 'Want to change the interview questions?',
        },
        ERRORS: {
          TITLE: 'Error generating interview',
          QUESTIONS_EMPTY: 'Some questions are blank. Please review them before continuing.',
          QUESTION_UNSAVED: 'You have unsaved changes in a question. Click "Stay" to save it, or "Leave without saving" to discard the changes and continue.',
        },
      },
      LOADING: {
        LOADING_OFFER: 'Loading job...',
        PUBLISH_OFFER: 'Don\'t close this page, we\'re publishing your job.',
        GENERATING_OFFER: 'Generating job description</br> using AI...',
        GENERATING_DESCRIPTION: 'Drafting the job description for <b>"{{ title }}"</b>:',
        AI_INPUT_PLACEHOLDER: 'Use the AI bar to request tweaks...',
      },
      TAGS_HELP: 'Press Comma or Enter to add a tag',
      LANDING: {
        GREETING: 'Hi {{ username }}!',
        QUESTION: 'Would you like to create a new job or duplicate an existing one?',
        CREATE_NEW: 'Create new job',
        DUPLICATE_EXISTING: 'Duplicate a job',
      },
      DUPLICATE: {
        TITLE: 'Press the "Duplicate job" button on the job you want to duplicate',
        BACK: 'Back',
        DUPLICATE_BTN: 'Duplicate job (useful for recurring positions)',
      },
      TITLE_CREATE: 'Create a job posting',
      TITLE_EDIT: 'Edit the job posting',
    },
    INTERVIEW: {
      LOADING: 'Generating AI Interview</br> for your job post...',
      LOADING_MANUAL_CREATION: 'Preparing interview editor...',
      AI_PROMPT: {
        PLACEHOLDER: 'Type your adjustments for the questions here...',
        SUGGESTIONS: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          1: 'Make the questions longer',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          2: 'Use a more formal tone',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          3: 'Start with an icebreaker',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          4: 'Focus more on hard skills',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          5: 'Ask about experience in similar roles',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          6: 'Ask how they handle pressure',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          7: 'Make them friendly and conversational',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          8: 'Ask about core values and teamwork',
        },
      },
      SELECTION: {
        TITLE: 'Video Interview',
        SUBTITLE: 'Generate a video interview based on your job post. You can send it later to selected candidates directly from your Dashboard.',
        QUESTIONS: {
          LABEL: 'Number of questions',
          PLACEHOLDER: 'Select amount',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          1: '1 question',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          2: '2 questions',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          3: '3 questions',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          4: '4 questions',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          5: '5 questions',
        },
        BUTTONS: {
          GENERATE: 'Generate with AI',
          MANUAL: 'Write them myself',
          SKIP: 'Maybe later',
        },
      },
      QUESTIONS: {
        TITLE: 'Awesome!',
        INFO: 'Draft the questions you want to ask candidates applying for {{ title }}. You can send this interview later from your Jobs dashboard.',
        INFO_IA: 'Here are some AI-generated questions for the {{ title }} role. You can tweak them and send them later from your Jobs dashboard.',
        DEFAULT: 'Click the pencil icon to edit the interview questions.',
        QUESTION: 'Question {{ number }}',
        ADD: '+ Add another question',
        DELETE: 'Delete',
      },
    },
    PREVIEW: {
      TITLE: 'Job summary',
      SUMMARY: 'Summary',
      REQUIREMENTS: 'Requirements',
      OFFER: 'Job post',
      REQUIREMENTS_MINIMUM: {
        TITLE: 'Minimum qualifications',
        EXPERIENCE: 'Experience',
        FORMATION: 'Education',
        OTHER: 'Other',
        LANGUAGES: 'Languages',
      },
      REQUIREMENTS_DESIRED: { TITLE: 'Preferred qualifications' },
      INTERVIEW: {
        TITLE: 'Video Interview',
        EMPTY: 'No interview configured',
      },
      EDIT: 'Edit',
      PUBLISH: 'Publish job',
      PUBLISH_SUCCESS: 'Job posted successfully!',
      DIALOG: {
        HEADER: 'Cancel edits',
        MESSAGE: 'Are you sure you want to cancel? Unsaved changes will be lost.',
        ACCEPT: 'Keep editing',
        REJECT: 'Discard changes',
      },
      GUARD: {
        EDITION_HEADER: 'Cancel job creation',
        EDITION_MESSAGE: 'Are you sure you want to cancel? Your progress will be lost.',
        EDITION_ACCEPT: 'Cancel creation',
        EDITION_REJECT: 'Keep creating',
      },
    },
    COPY: {
      LINK_SUCCESS: 'Job link copied to clipboard.',
      DATA_SUCCESS: 'Job details copied to clipboard. You can paste them directly into LinkedIn or other platforms.',
      QR_SUCCESS: 'QR code copied to clipboard as image.',
      DATA_TOOLTIP: 'Copy all job details to share or publish it',
      LINK_TOOLTIP: 'Copy the job link',
      QR_TOOLTIP: 'Copy the QR code to share or publish it',
      SECTION: {
        TITLE: 'Job title',
        TYPE: 'Work mode',
        LOCATION: 'Location',
        SALARY: 'Salary',
        WORKING_DAY: 'Working hours',
        CONTRACT_TYPE: 'Employment type',
        PRESENTATION: 'Intro',
        MIN_REQUIREMENTS: 'Minimum requirements',
        FORMATION: 'Education',
        EXPERIENCE: 'Experience',
        OTHER: 'Other',
        LANGUAGES: 'Languages',
        DESIRED_REQUIREMENTS: 'Desired requirements',
        DESCRIPTION: 'Description',
        APPLY_HERE: 'Apply here',
      },
    },
    // Ref: docs/libraries/Angular v18 Documentation.txt
    APP_PREVIEW: {
      NON_INTERACTIVE_TOOLTIP: 'This is only a preview. Download the wokap application to test the full experience.',
      COMPANY_VIEW: 'View company',
    },
    PUBLISH: {
      TITLE: 'Job posted successfully!',
      FIRST_APPLICANTS_NOTICE: 'We\'ll email you once the first 5 candidates apply.',
      SUBTITLE: 'Share your job by copying the link, data or QR code to post it on social media, websites or wherever you like.',
      PREVIEW_INFO: 'To see how your job post will appear to candidates, download the wokap app or use the preview below.',
      PREVIEW_BUTTON: 'Preview',
      EDIT_INFO: 'Want to make changes? Edit it right here.',
      EDIT_BUTTON: 'Edit job',
      INFO: 'Manage your job, interviews and candidates from the wokap "Jobs Dashboard".',
      COPY_SUCCESS: 'Link copied to clipboard.',
      COPY_ERROR: 'Failed to copy link. Please try again.',
      COPY_QR_ERROR: 'Failed to copy QR code. Please try again.',
      BUTTON: 'View Job',
      BUTTON_PANEL: 'Go to Jobs Dashboard',
      BUTTON_PLATFORMS: 'Publish on Job Boards',
      SUGGESTED_MODAL: {
        HEADER: 'wokap AI found matches for you!',
        MESSAGE: 'We found candidates who match your role. Check them out in the Suggested Candidates section.',
        ACCEPT: 'View suggested candidates',
        REJECT: 'Go to job',
      },
    },
    CANDIDATE_DETAIL: {
      TITLE: 'Candidate',
      OFFER_TITLE: 'Job: {{ offer }}',
      PENDING_CLASSIFICATION: 'Unrated',
      EDUCATION: 'Education',
      WORK_EXPERIENCE: 'Experience',
      CURRICULUM: 'Resume',
      DOWNLOAD_CV: 'Download',
      LANGUAGES: 'Languages',
      CANDIDATE: 'Candidate',
      PRESENTATION: 'Intro',
      QUESTION: 'Question {{ num }}',
      SPECIFIC_QUESTIONS: { TITLE: 'Direct questions' },
      ACTIONS: {
        EVALUATION: {
          BUTTON: 'Rate candidate',
          CONFIRM: {
            TITLE: 'Rating',
            CONFIRM: 'Apply',
          },
          NOTIFICATION: {
            TITLE: 'Rating',
            SUCCESS: { TEXT: 'Candidate rated successfully.' },
            ERROR: { TEXT: 'Failed to rate candidate.' },
          },
        },
        CHAT: 'Chat',
        NOTES: {
          BUTTON: 'Notes',
          SIDEBAR: {
            TITLE: 'Notes',
            ADD: 'Add note',
            NOTE: {
              PLACEHOLDER: 'This note is internal and only visible to your team.\nThe candidate cannot see it.',
              EDIT: 'Edit',
              SAVE: 'Save',
              DELETE: 'Delete',
              DISCARD: 'Discard',
              CREATED_BY: 'Logged by ',
              CREATED_BY_ME: 'Logged by you ',
            },
            SUCCESS: { COMMENT_DELETED: 'Note deleted successfully.' },
            ERRORS: {
              APPLY_OFFER_NOT_FOUND: 'The selected job does not exist.',
              COMMENT_NOT_BLANK: 'Note cannot be empty.',
              APPLY_OFFER_COMMENT_NOT_FOUND: 'Note not found.',
              COMMENT_NOT_CREATED_BY_YOU: 'You can only edit your own notes.',
            },
          },
        },
        BACK_TO_REVIEW: {
          BUTTON: 'Move candidate',
          CONFIRM: {
            TITLE: 'Advance candidate',
            MESSAGE: 'Are you sure you want to advance this candidate to the next stage?',
            CONFIRM: 'Advance',
            CANCEL: 'Cancel',
          },
          MULTIPLE_CONFIRM: {
            TITLE: 'Advance candidates',
            MESSAGE: 'Are you sure you want to advance these candidates to the next stage?',
            CONFIRM: 'Advance',
            CANCEL: 'Cancel',
          },
          NOTIFICATION: {
            TITLE: 'Moved',
            SUCCESS: { TEXT: 'Candidate moved successfully.' },
            ERROR: { TEXT: 'Failed to move candidate.' },
          },
        },
        START_PROCESS: {
          BUTTON: 'Shortlist',
          CONFIRM: {
            TITLE: 'Shortlist',
            MESSAGE: 'Are you sure you want to shortlist this candidate and move them forward?',
            CONFIRM: 'Shortlist',
            CANCEL: 'Cancel',
          },
          MULTIPLE_CONFIRM: {
            TITLE: 'Shortlist candidates',
            MESSAGE: 'Are you sure you want to shortlist these candidates and move them forward?',
            CONFIRM: 'Shortlist',
            CANCEL: 'Cancel',
          },
          NOTIFICATION: {
            TITLE: 'Success',
            SUCCESS: { TEXT: 'Candidate shortlisted successfully.' },
            ERROR: { TEXT: 'Failed to move candidate forward.' },
          },
        },
        SEND_INTERVIEW: {
          BUTTON: 'Send interview',
          BUTTON_NO_INTERVIEW: 'Start process',
          CONFIRM: {
            TITLE: 'Send interview',
            MESSAGE: 'Are you sure you want to send the interview to this candidate?',
            CONFIRM: 'Send',
            CANCEL: 'Cancel',
          },
          MULTIPLE_CONFIRM: {
            TITLE: 'Send interviews',
            MESSAGE: 'Are you sure you want to send the interviews to these candidates?',
            CONFIRM: 'Send',
            CANCEL: 'Cancel',
          },
          NOTIFICATION: {
            TITLE: 'Sent',
            SUCCESS: { TEXT: 'Interview sent successfully.' },
            ERROR: { TEXT: 'Failed to send interview.' },
          },
        },
        RE_SEND_INTERVIEW: {
          BUTTON: 'Resend interview',
          CONFIRM: {
            TITLE: 'Resend interview',
            MESSAGE: 'The interview was already sent, but hasn\'t been completed yet.<br/><br/>Click Resend.',
            CONFIRM: 'Resend',
            CANCEL: 'Cancel',
          },
          MULTIPLE_CONFIRM: {
            TITLE: 'Resend interviews',
            MESSAGE: 'The interviews were already sent, but haven\'t been completed yet.<br/><br/>Click Resend.',
            CONFIRM: 'Resend',
            CANCEL: 'Cancel',
          },
          NOTIFICATION: {
            TITLE: 'Resent',
            SUCCESS: { TEXT: 'Interview resent successfully.' },
            ERROR: { TEXT: 'Failed to resend interview.' },
          },
        },
        SELECT: {
          BUTTON: 'Advance to finalist',
          CONFIRM: {
            TITLE: 'Advance candidate',
            MESSAGE: 'Are you sure you want to advance this candidate to the next stage?',
            CONFIRM: 'Advance',
            CANCEL: 'Cancel',
          },
          MULTIPLE_CONFIRM: {
            TITLE: 'Advance candidates',
            MESSAGE: 'Are you sure you want to advance these candidates to the next stage?',
            CONFIRM: 'Advance',
            CANCEL: 'Cancel',
          },
          NOTIFICATION: {
            TITLE: 'Finalist',
            SUCCESS: { TEXT: 'Candidate advanced to finalist stage.' },
            ERROR: { TEXT: 'Failed to advance candidate.' },
          },
        },
        DISCARD: {
          BUTTON: 'Reject',
          DISCARDED_NOTE_PREFIX: 'REJECTED BY:',
          CONFIRM: {
            TITLE: 'Reject candidate',
            MESSAGE: 'Are you sure you want to reject this candidate?',
            TEXTAREA_PLACEHOLDER: 'Leave a reason here. This is internal and will not be shared with the candidate.',
            CONFIRM: 'Reject',
            CANCEL: 'Cancel',
          },
          MULTIPLE_CONFIRM: {
            TITLE: 'Reject candidates',
            MESSAGE: 'Are you sure you want to reject these candidates?',
            TEXTAREA_PLACEHOLDER: 'Leave a reason here. This is internal and will not be shared with the candidates.',
            CONFIRM: 'Reject',
            CANCEL: 'Cancel',
          },
          NOTIFICATION: {
            TITLE: 'Rejected',
            SUCCESS: { TEXT: 'Candidate rejected successfully.' },
            ERROR: { TEXT: 'Failed to reject candidate.' },
          },
        },
        BULK_RESULT: {
          PARTIAL: 'Action applied to {applied} and skipped for {skipped} candidates.',
          NOTHING_APPLIED: 'The action was not applied to any of the {skipped} candidates.',
        },
        SKIP_REASON: {
          ALREADY_DISCARDED: 'already rejected',
          ALREADY_SELECTED: 'already finalists',
          ALREADY_IN_PROCESS: 'already in process',
          ALREADY_IN_REVIEW: 'already in review',
          CANDIDATE_NOT_DISCARDED: 'not rejected',
          INTERVIEW_ALREADY_ANSWERED: 'interview already answered',
          INTERVIEW_NOT_FOUND: 'no interview',
          ACCESS_DENIED: 'access denied',
          ERROR_ACTION: 'error applying the action',
          GENERIC: 'unspecified reason',
          CANDIDATE_NOT_SUGGESTED: 'not suggested',
          CHAT_ERROR: 'chat error',
        },
        ADD_NOTE: {
          CONFIRM: {
            TITLE: 'Add note',
            MESSAGE: 'This note will be added to the candidate.',
            TEXTAREA_PLACEHOLDER: 'Write the note here. Only you and your team can see it.',
            CONFIRM: 'Add note',
            CANCEL: 'Cancel',
          },
          MULTIPLE_CONFIRM: {
            TITLE: 'Add note to candidates',
            MESSAGE: 'The same note will be added to all selected candidates.',
            TEXTAREA_PLACEHOLDER: 'Write the note here. Only you and your team can see it.',
            CONFIRM: 'Add note',
            CANCEL: 'Cancel',
          },
          NOTIFICATION: {
            TITLE: 'Note',
            SUCCESS: { TEXT: 'Note added successfully.' },
            ERROR: { TEXT: 'Failed to add the note.' },
          },
        },
        ROLLBACK_DISCARD: {
          BUTTON: 'Restore',
          TOOLTIP: 'Restore rejected candidate',
          CONFIRM: {
            TITLE: 'Restore candidate',
            MESSAGE: 'Are you sure you want to restore this candidate?<br/><br/>They will be returned to their previous stage.',
            CONFIRM: 'Restore',
            CANCEL: 'Cancel',
          },
          MULTIPLE_CONFIRM: {
            TITLE: 'Restore candidates',
            MESSAGE: 'Are you sure you want to restore these candidates?<br/><br/>They will be returned to their previous stages.',
            CONFIRM: 'Restore',
            CANCEL: 'Cancel',
          },
          NOTIFICATION: {
            TITLE: 'Restored',
            SUCCESS: { TEXT: 'Candidate restored successfully.' },
            ERROR: { TEXT: 'Failed to restore candidate.' },
          },
        },
        DISCARDED_ACTION_BLOCKED: {
          TITLE: 'Candidate rejected',
          MESSAGE: 'Restore them to continue the process.',
          CONFIRM: 'Restore',
          CANCEL: 'Cancel',
        },
        SEND_MESSAGE: {
          CONFIRM: {
            TITLE: 'Send message',
            MESSAGE: 'Are you sure you want to send this message?',
            TEXTAREA_PLACEHOLDER: 'Type your message here.',
            CONFIRM: 'Send',
            CANCEL: 'Cancel',
          },
          MULTIPLE_CONFIRM: {
            TITLE: 'Send bulk message',
            MESSAGE: 'Are you sure you want to send this message to the selected candidates?',
            TEXTAREA_PLACEHOLDER: 'Type your message here.',
            CONFIRM: 'Send',
            CANCEL: 'Cancel',
          },
          NOTIFICATION: {
            TITLE: 'Message sent',
            SUCCESS: { TEXT: 'Message sent successfully.' },
            ERROR: { TEXT: 'Failed to send message.' },
          },
        },
        CREATE_INTERVIEW: {
          CONFIRM: {
            TITLE: 'Create interview',
            MESSAGE: 'Are you sure you want to set up an interview for this job?',
            CONFIRM: 'Create',
            CANCEL: 'Cancel',
          },
          TOOLTIP: 'Create an interview for this job',
        },
        SEND_OFFER_TO_SUGGESTED: {
          CONFIRM: {
            TITLE: 'Send invite',
            MESSAGE: 'Are you sure you want to invite this person to apply to the job?',
            CONFIRM: 'Send invite',
            CANCEL: 'Cancel',
          },
          MULTIPLE_CONFIRM: {
            TITLE: 'Send bulk invites',
            MESSAGE: 'Are you sure you want to invite these people to apply to the job?',
            CONFIRM: 'Send invites',
            CANCEL: 'Cancel',
          },
          NOTIFICATION: {
            TITLE: 'Invites sent',
            SUCCESS: { TEXT: 'Invitations sent successfully.' },
            ERROR: { TEXT: 'Failed to send invitations.' },
          },
        },
        DISCARD_SUGGESTED: {
          CONFIRM: {
            TITLE: 'Dismiss suggested candidate',
            MESSAGE: 'Are you sure you want to dismiss this candidate? They will be removed from your suggestions permanently.',
            CONFIRM: 'Dismiss',
            CANCEL: 'Cancel',
          },
          MULTIPLE_CONFIRM: {
            TITLE: 'Dismiss suggested candidates',
            MESSAGE: 'Are you sure you want to dismiss these candidates? They will be removed from your suggestions permanently.',
            CONFIRM: 'Dismiss',
            CANCEL: 'Cancel',
          },
          NOTIFICATION: {
            TITLE: 'Dismissed',
            SUCCESS: { TEXT: 'Candidates dismissed successfully.' },
            ERROR: { TEXT: 'Failed to dismiss candidates.' },
          },
        },
      },
      INTERVIEW: {
        TITLE: 'Interview',
        NOT_SEND: {
          TITLE: 'Interview not sent',
          TEXT: 'You haven\'t sent the interview yet. Click <b>Send interview</b> to notify the candidate.',
        },
        QUESTION: {
          NO_ANSWER: {
            TITLE: 'No answer',
            TEXT: 'The candidate hasn\'t answered this question.',
          },
        },
        SEND_WITHOUT_ANSWER: {
          TITLE: 'No answer',
          TEXT: 'The interview was sent, but the candidate hasn\'t completed it. Click <b>Resend</b>.',
        },
        NO_INTERVIEW: {
          TITLE: 'No interview',
          TEXT: 'This job has no interview set up.',
        },
      },
      TABLE: {
        TITLE: 'Candidate history',
        HEADER: {
          CREATED_BY: 'Author',
          MESSAGE: 'Message',
          CREATED_AT: 'Date',
          STATUS: 'Action',
        },
      },
      TAGS: 'Tags',
      REQUIREMENTS: 'Qualifications',
      REQUIREMENTS_MET: '{{ current }} of {{ total }}',
      NEXT: 'Next',
      PREVIOUS: 'Previous',
      CONFIRM_DISCARD: {
        HEADER: 'Discard changes',
        MESSAGE: 'You have unsaved changes. Are you sure you want to leave?',
        ACCEPT: 'Leave',
        REJECT: 'Cancel',
      },
    },
    SUCCESS: {
      DUPLICATED: 'Job duplicated successfully',
      DUPLICATED_AND_REDIRECTING: 'Job duplicated successfully. Redirecting...',
      PIN_TOGGLED: 'Pin status updated successfully',
    },
  },
} as const;
